import { FC } from "react";
import { LinearProgress } from "@mui/material";

interface ContentLoaderProps {
    isLoading?: boolean
}

export const ContentLoader: FC<ContentLoaderProps> = ({isLoading = false}) => {
    return <>{isLoading && <LinearProgress sx={{ height: '1px' }}/>}</>
}